var map = {
	"./Pattern01.png": "18e0",
	"./Pattern02.png": "07af",
	"./Pattern03.png": "e8dd",
	"./Pattern04.png": "12fd",
	"./Pattern05.png": "b61d",
	"./Pattern06.png": "dfef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ae1f";